import React from "react";
import { withRouter } from "react-router-dom";
import { Link } from 'react-router-dom';
import DefaultView from "../../layouts/content/DefaultView/DefaultView";

function NotFoundPage(props) {

  return (
    <DefaultView>
      <div className={"ui-default-headline"}>Ooops!! Not found :-(</div>
      <div>
        Try to go back or<br/>
        <Link
          to=""
          onClick={(e) => {
            e.preventDefault();
            props.history.goBack();
          }}
        >
          click here!
        </Link>
      </div>
    </DefaultView>
  );
}

export default withRouter(NotFoundPage);
